export const partnerList = {
    tiny_title: "Media Partner",
    title : "Telah Diliput Oleh"
}